module.exports = __webpack_public_path__ + "static/media/ambrussum_strassenstation_tn.c8c3ec12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/ambrussum_strassenstation_tn.jpg
// module id = 700
// module chunks = 0